import { ClickEvent } from "@mcleod/components/src/events/ClickEvent";
import { AutogenLayoutDataFusionControl } from "./autogen/AutogenLayoutDataFusionControl";
import { McLeodClassicIntegration } from "@mcleod/core/src/McLeodClassicIntegration";
import { ChangeEvent, Switch } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";




export class DataFusionControl extends AutogenLayoutDataFusionControl {

    override onLoad(): void {
         this.savebuttonMain.extraDataSources = [
            this.sourceEdiControlShared,
            this.sourceEdiLoggerSetting,
            this.sourceEdiProcessSetting
        ];

    }

    sourceEdiControlAfterExecution() {
        this.tabIntercompany.visible = this.sourceEdiControl.activeRow.get("intercompany_enabled", false);
    }

    switchIntercompanyEnabledOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange) {
            const icSwitch = event.target as Switch;
            if(icSwitch.checked) {
                CommonDialogs.showYesNo("Enabling IntercompanyFusion processing will alter your intercompany profiles by removing the DataFusion communications. " +
                    "The appropriate sending or receiving company must be assigned on each intercompany profile. To track orders on the intercompany panel, " +
                    "the 204 intercompany templates need to be updated to include the intercompany key mapping.").then((result) => {
                        if(!result) {
                            icSwitch.checked = false;
                            this.mainDataSource.activeRow.set("intercompany_enabled", false);
                        }
                    });
            }

            if(!icSwitch.checked) {
                CommonDialogs.showYesNo("Disabling IntercompanyFusion will alter your intercompany profiles by removing the sending/receiving company.  " +
                    "Please assign the appropriate communications for intercompany profiles. Do you wish to continue?").then((result) => {
                        if(!result) {
                            icSwitch.checked = true;
                            this.mainDataSource.activeRow.set("intercompany_enabled", true);
                        }
                    });
            }
        }
    }

    buttonOpenClassicOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.EntryEdiControl", this.mainDataSource.activeRow.get("id"));
    }

}
